import { SPACING } from '@alto/design-library-tokens';
import { ActionSheetV2, Description, InlineAlert, LgPadding, XsSpacing, XxsSpacing } from '@alto/design-system';
import { type FertilityCycleMedicationType } from '@alto/scriptdash/alto/fertility_cycles/types/v1/fertility_cycle_medication_type';
import React from 'react';
import { CALCULATION_INFO_STRINGS, MEDICATION_TYPES_DISPLAY } from '../constants';
import { NumberedStep } from './NumberedStep';

type Props = {
  readonly medicationType: FertilityCycleMedicationType;
};

export const CalculationInfoActionSheet = ({ medicationType }: Props) => {
  const strings = CALCULATION_INFO_STRINGS[medicationType];
  return (
    // eslint-disable-next-line @alto/require-analytics-name-for-action-sheet
    <ActionSheetV2 title={`Calculate ${MEDICATION_TYPES_DISPLAY[medicationType]} on hand`}>
      <NumberedStep number={1}>{strings.STEP_1}</NumberedStep>
      <XsSpacing />
      <NumberedStep number={2}>{strings.STEP_2}</NumberedStep>
      <XsSpacing />
      <NumberedStep number={3}>{strings.STEP_3}</NumberedStep>
      <LgPadding topPadding={SPACING.STATIC.MD}>
        <InlineAlert>
          <Description fontFamily="semibold">Example</Description>
          <XxsSpacing />
          <Description>{strings.EXAMPLE}</Description>
        </InlineAlert>
      </LgPadding>
    </ActionSheetV2>
  );
};
